import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExitIntentNewComponent } from './exit-intent-new.component';
import { ButtonModule } from '../button/button.module';
import { FbShareModule } from '../fb-share/fb-share.module';
import { WhatsappShareModule } from '../whatsapp-share/whatsapp-share.module';



@NgModule({
  declarations: [
    ExitIntentNewComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,
    FbShareModule,
    WhatsappShareModule
  ],
  bootstrap: [ExitIntentNewComponent],
  exports: [ExitIntentNewComponent]
})
export class ExitIntentNewModule { }
